import { useEffect, useState } from "react";
import {
    FaBars,
    FaChevronDown,
    FaMicrochip,
    FaPaperPlane,
    FaTimes,
    FaUserPlus,
} from "react-icons/fa";

import styles from "./Navbar.module.css";
import { useNavigate } from "react-router-dom";
import ieelogo from "../../assets/images/ieee-logo.png";
import edslogo from "../../assets/images/ieee-eds-logo.png";
import iveclogo from "../../assets/images/ivecicon.png";


const NAV_ITEMS = [
    { type: "link", label: "Home", id: "top" },
    {
        type: "dropdown",
        label: "Submission of Abstracts",
        key: "submission",
        items: [
            { label: "Author Instructions & Templates", id: "author-instructions" },
            { label: "Initial Abstract Submission", id: "author-instructions" },
            { label: "Conference Topics", id: "topics" },
            { label: "Final Paper Submission", id: "topics" },
            { label: "Presenter Instructions", id: "topics" },
        ],
    },
    {
        type: "dropdown",
        label: "Programme",
        key: "programme",
        items: [
            { label: "Final Programme", id: "programme" },
            { label: "Mini Courses", id: "programme" },
            { label: "Plenary Talks", id: "programme" },
        ],
    },
    { type: "link", label: "Calendar of Events", id: "calendar-section" },
    { type: "link", label: "Sponsors & Exhibitors", id: "sponsors" },
    // { type: "link", label: "Registration", id: "registration" },
    { type: "link", label: "Destination", id: "venue-section" },
    {
        type: "dropdown",
        label: "VISA Information",
        key: "visa",
        items: [
            { label: "Invitation Letters", id: "visa-help" },
            { label: "Documentation", id: "visa-help" },
        ],
    },
    { type: "link", label: "Awards", id: "awards" },
    {
        type: "dropdown",
        label: "Committees",
        key: "committees",
        items: [
            { label: "IVEC", id: "ivec" },
            { label: "EDC", id: "edc" },
        ],
    },
];

const Navbar = () => {

    const navigate = useNavigate();
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [openAccordion, setOpenAccordion] = useState(null);

    const goTo = (id) => {
        navigate(id === "top" ? "/" : `/${id}`);
        setDrawerOpen(false);
        setOpenAccordion(null);
    };

    const goSubmitPaper = () => {
        window.open('https://edas.info/newPaper.php?c=35646', '_blank', 'noopener,noreferrer');
    };

    const toggleAccordion = (key) => {
        setOpenAccordion((prev) => (prev === key ? null : key));
    };

    // Lock body scroll while the drawer is open, and allow Esc to close it.
    useEffect(() => {
        if (drawerOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        const onKeyDown = (e) => {
            if (e.key === "Escape") setDrawerOpen(false);
        };
        window.addEventListener("keydown", onKeyDown);

        return () => {
            document.body.style.overflow = "";
            window.removeEventListener("keydown", onKeyDown);
        };
    }, [drawerOpen]);

    return (
        <>
            {/* =====================================================
                TOP HEADER
            ===================================================== */}
            <header className={styles.topHeader}>
                <div className="container-fluid px-3 px-lg-5">
                    <div className="d-flex justify-content-between align-items-center">

                        <button
                            className={styles.brand}
                            onClick={() => goTo("top")}
                        >
                            <div className={styles.brandIcon}>
                                 <img src={iveclogo.src || iveclogo} alt="IVEC Logo" className={styles.brandIconImg} />
                            </div>

                            <div>
                                <div className={styles.brandTitle}>
                                    IVEC 2027
                                </div>

                                <div className={styles.brandSubtitle}>
                                    International Vacuum Electronics Conference
                                </div>
                            </div>
                        </button>

                        <div className={styles.organizationArea}>
                            <div className={styles.organizationLogo}>
                                <img src={ieelogo.src || ieelogo} alt="IEEE Logo" className={styles.logoImg} />
                            </div>

                            <div className={styles.logoDivider}></div>

                            <div className={styles.organizationLogoSmall}>
                                <img src={edslogo.src || edslogo} alt="IEEE EDS Logo" className={styles.logoImgSmall} />
                            </div>

                            <div className={styles.logoDivider}></div>

                            <div className={styles.vedaLogo}>
                                VEDAS
                            </div>
                        </div>

                    </div>
                </div>
            </header>

            {/* =====================================================
                NAVIGATION (desktop hover bar)
            ===================================================== */}
            <nav className={styles.navbar}>
                <div className="container-fluid px-3 px-lg-5">

                    <div className="d-flex align-items-center justify-content-between">

                        <div className={styles.mobileBrand}>
                            <FaMicrochip />
                            <span>IVEC 2027</span>
                        </div>

                        <button
                            className={styles.mobileMenuButton}
                            onClick={() => setDrawerOpen(true)}
                            aria-label="Open menu"
                            aria-expanded={drawerOpen}
                        >
                            <FaBars />
                        </button>

                        <div className={styles.navContent}>
                            <div className={styles.navLinks}>

                                {NAV_ITEMS.map((item) =>
                                    item.type === "link" ? (
                                        <button
                                            key={item.label}
                                            onClick={() => goTo(item.id)}
                                            className={styles.navLink}
                                        >
                                            {item.label}
                                        </button>
                                    ) : (
                                        <div className={styles.navDropdown} key={item.key}>
                                            <button className={styles.navLink}>
                                                {item.label}
                                                <FaChevronDown />
                                            </button>

                                            <div className={styles.dropdownMenu}>
                                                {item.items.map((sub) => (
                                                    <button
                                                        key={sub.label}
                                                        onClick={() => goTo(sub.id)}
                                                    >
                                                        {sub.label}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    )
                                )}

                            </div>

                            <div className={styles.navActions}>
                                <button
                                    onClick={() => goSubmitPaper()}
                                    className={styles.submitButton}
                                >
                                    Submit Paper
                                    <FaPaperPlane />
                                </button>

                                <button
                                    onClick={() => goTo("registration")}
                                    className={styles.registerButton}
                                >
                                    Register Now
                                    <FaUserPlus />
                                </button>
                            </div>

                        </div>

                    </div>
                </div>
            </nav>

            {/* =====================================================
                MOBILE DRAWER
            ===================================================== */}
            <div
                className={`${styles.drawerOverlay} ${drawerOpen ? styles.drawerOverlayOpen : ""}`}
                onClick={() => setDrawerOpen(false)}
                aria-hidden={!drawerOpen}
            />

            <aside
                className={`${styles.drawer} ${drawerOpen ? styles.drawerOpen : ""}`}
                aria-hidden={!drawerOpen}
            >
                <div className={styles.drawerHeader}>
                    <div className={styles.mobileBrand}>
                        <FaMicrochip />
                        <span>IVEC 2027</span>
                    </div>

                    <button
                        className={styles.drawerClose}
                        onClick={() => setDrawerOpen(false)}
                        aria-label="Close menu"
                    >
                        <FaTimes />
                    </button>
                </div>

                <div className={styles.drawerBody}>
                    {NAV_ITEMS.map((item) =>
                        item.type === "link" ? (
                            <button
                                key={item.label}
                                className={styles.drawerLink}
                                onClick={() => goTo(item.id)}
                            >
                                {item.label}
                            </button>
                        ) : (
                            <div className={styles.drawerAccordion} key={item.key}>
                                <button
                                    className={styles.drawerLink}
                                    onClick={() => toggleAccordion(item.key)}
                                    aria-expanded={openAccordion === item.key}
                                >
                                    {item.label}
                                    <FaChevronDown
                                        className={`${styles.drawerChevron} ${openAccordion === item.key ? styles.drawerChevronOpen : ""
                                            }`}
                                    />
                                </button>

                                <div
                                    className={`${styles.drawerSubmenu} ${openAccordion === item.key ? styles.drawerSubmenuOpen : ""
                                        }`}
                                >
                                    <div className={styles.drawerSubmenuInner}>
                                        {item.items.map((sub) => (
                                            <button
                                                key={sub.label}
                                                onClick={() => goTo(sub.id)}
                                            >
                                                {sub.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )
                    )}
                </div>

                <div className={styles.drawerActions}>
                    <button
                        onClick={() => goTo("author-instructions")}
                        className={styles.submitButton}
                    >
                        Submit Paper
                        <FaPaperPlane />
                    </button>

                    <button
                        onClick={() => goTo("registration")}
                        className={styles.registerButton}
                    >
                        Register Now
                        <FaUserPlus />
                    </button>
                </div>
            </aside>
        </>
    );
};

export default Navbar;